import { ReadinessModel, RouteClass } from "../contracts/common.js";
import {} from "../contracts/result.js";
import { expectArray, expectNumber, expectObject, expectOptionalNumber, readField, readOptionalField, } from "../internal/json.js";
import { createQuery } from "../internal/query.js";
import { requestJsonResult } from "../internal/transport.js";
const METRICS_LATEST_ROUTE = {
    method: "GET",
    name: "metricsLatest",
    path: "/api/v1/metrics/latest",
    readinessModel: ReadinessModel.INDEXED,
    routeClass: RouteClass.INDEXED,
};
const METRICS_CHART_ROUTE = {
    method: "GET",
    name: "metricsChart",
    path: "/api/v1/metrics/chart",
    readinessModel: ReadinessModel.INDEXED,
    routeClass: RouteClass.INDEXED,
};
/**
 * Public route descriptors for metrics routes.
 */
export const metricsRouteDescriptors = {
    chart: METRICS_CHART_ROUTE,
    latest: METRICS_LATEST_ROUTE,
};
function parseBlockMetrics(value, path) {
    const object = expectObject(value, path);
    const creditPoolBalance = expectOptionalNumber(readOptionalField(object, "creditPoolBalance"), `${path}.creditPoolBalance`);
    return {
        height: expectNumber(readField(object, "height", path), `${path}.height`),
        txCount: expectNumber(readField(object, "txCount", path), `${path}.txCount`),
        utxosSpendable: expectNumber(readField(object, "utxosSpendable", path), `${path}.utxosSpendable`),
        utxosUnspendable: expectNumber(readField(object, "utxosUnspendable", path), `${path}.utxosUnspendable`),
        blockchainSize: expectNumber(readField(object, "blockchainSize", path), `${path}.blockchainSize`),
        ...(creditPoolBalance == null ? {} : { creditPoolBalance }),
        circulatingSupply: expectNumber(readField(object, "circulatingSupply", path), `${path}.circulatingSupply`),
        difficulty: expectNumber(readField(object, "difficulty", path), `${path}.difficulty`),
        hashrate: expectNumber(readField(object, "hashrate", path), `${path}.hashrate`),
    };
}
function parseMetricsChart(value, path) {
    const object = expectObject(value, path);
    return {
        asOfHeight: expectNumber(readField(object, "asOfHeight", path), `${path}.asOfHeight`),
        startHeight: expectNumber(readField(object, "startHeight", path), `${path}.startHeight`),
        endHeight: expectNumber(readField(object, "endHeight", path), `${path}.endHeight`),
        bucketBlocks: expectNumber(readField(object, "bucketBlocks", path), `${path}.bucketBlocks`),
        value: expectArray(readField(object, "value", path), `${path}.value`, parseBlockMetrics),
    };
}
function createMetricsChartQuery(params) {
    if (params == null) {
        return undefined;
    }
    const query = createQuery({
        blocks: params.blocks,
        points: params.points,
    });
    return query.size > 0 ? query : undefined;
}
/**
 * Build the metrics route family for one client transport context.
 */
export function buildMetricsRoutes(context) {
    return {
        async getChart(params) {
            const query = createMetricsChartQuery(params);
            return requestJsonResult(context, METRICS_CHART_ROUTE, METRICS_CHART_ROUTE.path, parseMetricsChart, ...(query == null ? [] : [{ query }]));
        },
        async getLatest() {
            return requestJsonResult(context, METRICS_LATEST_ROUTE, METRICS_LATEST_ROUTE.path, parseBlockMetrics);
        },
    };
}
//# sourceMappingURL=metrics.js.map